import dotProp from 'dot-prop-immutable';
import * as _ from 'lodash';
import {
  CREATE_PAGE,
  DELETE_PAGE,
  DELETE_PAGES,
  ADD_LAYOUT_TO_PAGE,
  ADD_TEXTURE_TO_PAGE,
  TOGGLE_IS_ACTIVE,
  REMOVE_PLACEHOLDERS_FROM_PAGE,
  ADD_DROPPED_IMAGE,
  REMOVE_TEXTURE_FROM_PAGE,
  REMOVE_DROPPED_IMAGE,
  REMOVE_DROPPED_IMAGES,
  UPDATE_PAGES_ORDER,
  CHANGE_IMAGE,
  ADD_COVER_TO_PAGE,
  ADD_DROPPED_IMAGE_CHANGED_LAYOUT,
  REMOVE_CHANGED_IMAGE,
  REORDER_PAGES,
  REORDER_DROPPED_IMAGES,
  ASSIGNE_IMAGE_ID_TO_PAGE_PLACEHOLDERS,
  CHANGE_PAGES_BACKGROUND_COLOR,
  CHANGE_PAGES_BACKGROUND_COLOR_BY_ID,
  LOAD_PAGES_BY_BOOK_ID,
  ADD_TEXT_TO_PAGE,
  DELETE_TEXT_FROM_PAGE,
  ADD_BACKGROUND_IMAGE_TO_PAGE,
  CHANGE_PAGES_BACKGROUND_IMAGES,
  ADD_BACKGROUND_PLACEHOLDER_TO_PAGE,
  ADD_BACKGROUND_PROP_TO_PAGE,
} from '../../action-types/entities/pages';
import { REORDER_PLACEHOLDERS } from '../../action-types/entities/placeholders';
import {
  createTexture,
  removeTexture,
  addImageToTexture,
  fillImageSize,
  addImageObject,
  removeImageFromTexture,
  resetAllTransformations,
  changeFillImageSize,
} from '../../actions/entities/placeholders';
import {
  calculateRatio,
  orderBy,
  convertObjectToArray,
  setLayoutByOrientation,
  getPages,
  getFillSize,
  orientation,
  GetActivePage,
} from '../../helpers';
import { getInnerLayouts } from '../../helpers/layouts';
import {
  getReorderedDroppedImages,
  fillImages,
  setImageToCenter,
  getEditorPlaceholderSizes,
  getImageOriginalSizes,
} from '../../helpers/pages';
import {
  autofillFinished,
} from './io';
import { createBackgroundPlaceholders } from './backgroundPlaceholders';
/**
 * page model
 * {
 *    preview: data:image,
 *    layout: id,
 *    placeholders: [id],
 *    order: int,
 * }
 */

export const createPage = page => ({
  type: CREATE_PAGE,
  page,
});

export const reorderPages = () => ({
  type: REORDER_PAGES,
});

export const reorderDroppedImages = (page, reorderedDroppedImages) => ({
  type: REORDER_DROPPED_IMAGES,
  page,
  reorderedDroppedImages,
});


export const createPageReorder = page => (dispatch) => {
  dispatch(createPage(page));
  dispatch(reorderPages());
};

export const deletePages = excludeID => ({
  type: DELETE_PAGES,
  excludeID,
});

export const deletePage = pageId => ({
  type: DELETE_PAGE,
  pageId,
});

export function defaultBackgroundPlaceholderSettings(allIdsLength, index) {
  return {
    order: allIdsLength + index,
  };
}

export function defaultTextureSettings(allIdsLength, index) {
  return {
    transformations: {
      scaleX: 1,
      scaleY: 1,
      rotate: 0,
      moveX: 0,
      moveY: 0,
      isFit: false,
      fillSizes: {
        width: 0,
        height: 0,
      },
    },
    cover: {
      text: '',
      color: '',
      backgroundColor: '',
      isHaveShadow: false,
      isHaveBorder: false,
      fontSize: 20,
      fontFamily: '',
    },
    DPI: {
      isSmall: false,
      isClicked: false,
    },
    image: 0,
    imageRatio: 1,
    isChanged: null,
    order: allIdsLength + index,
  };
}
export const autoFill = (maxNumberOfPages, isConvert = false, newImages = false) => (dispatch, getState) => {
  const images = orderBy(getState().entities.images.byId, 'imageOrder');

  let remainingImages = maxNumberOfPages;
  const coverImage = images.filter(image => 'isCover' in image);

  if (coverImage.length && !isConvert) {
    const firstPage = convertObjectToArray(getState().entities.pages.byId)[0];
    const {
      id: coverPageId,
    } = firstPage;

    const {
      id: firstImageId,
    } = coverImage[0];

    dispatch(addDroppedImageToPage(coverPageId, firstImageId));
  }

  Object.keys(images).forEach((key) => {
    if ('isCover' in images[key] || remainingImages === 0) {
      return;
    }
    remainingImages -= 1;
    const page = {
      preview: '',
      layout: 0,
      placeholders: [],
      isBabyPage: false,
      order: getState().entities.pages.allIds.length,
      isActive: false,
      isCover: false,
      backgroundColor: '#ffffff',
      texts: [],
    };

    dispatch(createPage(page));

    const pagesById = getState().entities.pages.byId;
    const pagesArray = convertObjectToArray(pagesById);
    const orderedPages = orderBy(pagesArray, 'order', 'desc');
    const [lastPage] = orderedPages.slice(0);


    if (lastPage !== undefined) {
      dispatch(addDroppedImageToPage(lastPage.id, images[key].id));
    }
  });

  dispatch(autofillFinished(true));
};


export const setLayoutToActivePage = (layoutId, pageId, targetIndex = false, imageIsDropped = true) => (dispatch, getState) => {
  const { isCover, isFrontFlyLeaf, isBackFlyLeaf } = getState().entities.pages.byId[pageId];
  // Assigne layout to page
  dispatch(addLayout(layoutId, pageId));
  const layoutByLayoutId = getState().entities.layouts.byId[layoutId];
  const {
    placeholders: layoutPlaceholders, backgroundPlaceholder,
  } = layoutByLayoutId;

  // const coverPrintSize = getCoverPrintSizes(layoutWidth, layoutHeight);
  // const { layoutHeight: templateHeight } = getState().bookProperties.dimensions;
  const ratio = 1;

  // Get page placeholders before refresh
  let currentPage = getState().entities.pages.byId[pageId];
  const { placeholders: prevplaceholders } = currentPage;
  const allIdsLength = getState().entities.placeholders.allIds.length;
  const allImageById = getState().entities.images.byId;
  const allIdsByBackgroundPlaceholdersLength = getState().entities.backgroundPlaceholders.allIds.length;

  // Reset page
  if (Object.keys(prevplaceholders).length) {
    for (const texture of prevplaceholders) {
      if (texture.placeholderId) {
        dispatch(removeTexture(texture.placeholderId));
      }
    }
    dispatch(removeplaceholdersFromPage(pageId));
  }

  let index = 0;
  // Refresh page.placeholders
  if (layoutPlaceholders) {
    for (const layoutPlaceholder of layoutPlaceholders) {
      const texture = Object.assign({}, calculateRatio(ratio, layoutPlaceholder), defaultTextureSettings(allIdsLength, index));
      dispatch(createTexture(texture));
      const stateOfPlaceholders = getState().entities.placeholders.allIds;
      const [placeholderId] = stateOfPlaceholders.slice(stateOfPlaceholders.length - 1);
      dispatch(addTexture(placeholderId, pageId));
      index += 1;
    }
  }

  // Set backgroundPlaceholder if exist
  if (backgroundPlaceholder) {
    let bgIndex = 0;
    for (const bgPlaceholder of backgroundPlaceholder) {
      const backgroundPlaceholders = Object.assign({}, calculateRatio(ratio, bgPlaceholder), defaultBackgroundPlaceholderSettings(allIdsByBackgroundPlaceholdersLength, bgIndex));
      dispatch(createBackgroundPlaceholders(backgroundPlaceholders));
      const stateOfPlaceholders = getState().entities.backgroundPlaceholders.allIds;
      const [placeholderId] = stateOfPlaceholders.slice(stateOfPlaceholders.length - 1);
      dispatch(addBackgroundPlaceholder(placeholderId, pageId));
      bgIndex += 1;
    }
  }


  // Page with fresh data
  currentPage = getState().entities.pages.byId[pageId];
  const {
    placeholders: placeholderSizes,
    droppedImages,
  } = currentPage;


  let orderedPagePlaceholders = isCover ? orderBy(placeholderSizes, 'order', 'desc') : placeholderSizes;
  if (droppedImages.length !== 0) {
    const innerPagesReorder = getReorderedDroppedImages(allImageById, droppedImages, layoutByLayoutId);
    const reorderedDroppedImages = imageIsDropped && !isCover ? innerPagesReorder : droppedImages;
    dispatch(reorderDroppedImages(currentPage, reorderedDroppedImages));
    const tempImageIdArray = [];

    Object.keys(placeholderSizes).forEach((element) => {
      const { placeholderId } = placeholderSizes[element];
      Object.keys(droppedImages).find((imageId) => {
        if ((_.includes(tempImageIdArray, imageId) === false) && allImageById[droppedImages[imageId].imageId].orientation === orientation(getState().entities.placeholders.byId[placeholderId].width, getState().entities.placeholders.byId[placeholderId].height)) {
          tempImageIdArray.push(imageId);
          return imageId;
        }
      });
    });

    const isHaveLayout = Object.values(placeholderSizes).map(element => getState().entities.placeholders.byId[element.placeholderId]);

    if (convertObjectToArray(droppedImages).length !== 0) {
      const innerPagesReorder = getReorderedDroppedImages(allImageById, droppedImages, layoutByLayoutId);
      const reorderedDroppedImages = imageIsDropped && !isCover ? innerPagesReorder : droppedImages;
      dispatch(reorderDroppedImages(currentPage, reorderedDroppedImages));
      const convertedReorderedDroppedImages = convertObjectToArray(reorderedDroppedImages);
      const fixOrderedDroppedImages = orderBy(droppedImages, 'fixedOrder', 'asc');
      convertObjectToArray(orderedPagePlaceholders).forEach((pagePlaceholder, index) => {
        const nextDroppedImage = isCover || isBackFlyLeaf || isFrontFlyLeaf ? fixOrderedDroppedImages[index] : convertedReorderedDroppedImages[index];
        if (nextDroppedImage) {
        // Assign imageId to placeholder
          if (isCover || isFrontFlyLeaf || isBackFlyLeaf || !imageIsDropped || tempImageIdArray.length !== isHaveLayout.length) {
            dispatch(addImageToTexture(nextDroppedImage.id, pagePlaceholder.placeholderId));
          }
        }
      });

      if (imageIsDropped && !isCover && tempImageIdArray.length === isHaveLayout.length) {
        dispatch(reorderPlaceholders(currentPage, allImageById));
      }


      const placeholderStateById = getState().entities.placeholders.byId;
      const imagesStateById = getState().entities.images.byId;
      const orderingMode = isCover ? 'desc' : 'asc';
      orderedPagePlaceholders = orderBy(placeholderSizes, 'order', orderingMode);
      const { bookSizes, cover, dimensions } = getState().bookProperties;

      const coverRatio = cover.coverSizes.heightInPx / dimensions.layoutHeight;
      convertObjectToArray(orderedPagePlaceholders).forEach((pagePlaceholder) => {
        setTimeout(() => {
          const { placeholderId } = pagePlaceholder;
          if (placeholderStateById[placeholderId].imageObject) {
            const fillSizes = fillImages(placeholderId, pagePlaceholder.order, reorderedDroppedImages, placeholderStateById, imagesStateById, bookSizes, coverRatio, isCover);
            dispatch(fillImageSize(fillSizes.fillsizes, fillSizes.placeholderId));
          }
        }, 0);
      });
    }
  }
};

// add related entities
export const addLayout = (layoutId, pageId) => ({
  type: ADD_LAYOUT_TO_PAGE,
  layoutId,
  pageId,
});
export const addTexture = (placeholderId, pageId) => ({
  type: ADD_TEXTURE_TO_PAGE,
  placeholderId,
  pageId,
});
export const addBackgroundPlaceholder = (placeholderId, pageId) => ({
  type: ADD_BACKGROUND_PLACEHOLDER_TO_PAGE,
  placeholderId,
  pageId,
});
export const setIsActive = pageId => ({
  type: TOGGLE_IS_ACTIVE,
  pageId,
});
export const removeplaceholdersFromPage = pageId => ({
  type: REMOVE_PLACEHOLDERS_FROM_PAGE,
  pageId,
});

export const removeDroppedImages = pageId => ({
  type: REMOVE_DROPPED_IMAGES,
  pageId,
});

export const adDroppedImageToPlaceholder = (pageId, imageId, isCover, placeholderId) => ({
  type: ADD_DROPPED_IMAGE,
  pageId,
  imageId,
  isCover,
  placeholderId,
});

export const addDroppedImage = (pageId, imageId, isCover, placeholderId) => (dispatch, getState) => {
  dispatch(adDroppedImageToPlaceholder(pageId, imageId, isCover, placeholderId));

  if (placeholderId) {
    const placeholders = getState().entities.placeholders.byId;
    const images = getState().entities.images.byId;
    const { bookProperties } = getState();
    const { bookSizes } = bookProperties;
    const coverRatio = 'heightInPx' in bookProperties.cover.coverSizes ? bookProperties.cover.coverSizes.heightInPx / bookProperties.dimensions.layoutHeight : 1;
    const activePage = GetActivePage(getState().entities.pages.byId);

    const center = setImageToCenter(placeholders, placeholderId, images, bookSizes, null, coverRatio, activePage.isCover);
    dispatch(resetAllTransformations(placeholderId, center));
  }
};


export const addDroppedImageChangedLayout = (
  pageId,
  imageId,
  droppedImageId,
) => ({
  type: ADD_DROPPED_IMAGE_CHANGED_LAYOUT,
  pageId,
  imageId,
  droppedImageId,
});
export const addCoverToPage = pageId => ({
  type: ADD_COVER_TO_PAGE,
  pageId,
});


function isNotBelivPage(pageType, orderedLayouts, droppedImages) {
  const coverPageLayouts = orderedLayouts.filter(layout => layout[pageType]);
  return coverPageLayouts.find(element => element.placeholders.length === Object.keys(droppedImages).length && element.placeholders[0].width > 0);
}

export const addDroppedImageToPage = (pageId, imageId) => (
  dispatch,
  getState,
) => {
  const isChange = dotProp.get(getState(), 'editorUI.imageChange.isChange');
  const image = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.droppedImages`,
  );
  const deletedImage = convertObjectToArray(image).find(element => element.imageId === 0);

  if (isChange && deletedImage) {
    const placeholders = dotProp.get(getState(), 'entities.placeholders.byId');
    const placeholdersImage = convertObjectToArray(placeholders).find(element => element.isChanged);
    const images = dotProp.get(getState(), `entities.images.byId.${imageId}`);
    dispatch(addDroppedImageChangedLayout(pageId, imageId, deletedImage.id));
    dispatch(addImageObject(placeholdersImage.id, images));

    const layoutplaceholders = dotProp.get(getState(), 'entities.placeholders.byId');
    const bookProperties = dotProp.get(getState(), 'bookProperties');
    const { bookSizes } = bookProperties;
    const imagesById = dotProp.get(getState(), 'entities.images.byId');
    const placeholdersSize = getEditorPlaceholderSizes(layoutplaceholders, placeholdersImage.id, bookSizes);
    const activePage = GetActivePage(dotProp.get(getState(), 'entities.pages.byId'));
    const origImageSize = getImageOriginalSizes(layoutplaceholders, placeholdersImage.id, imagesById, activePage.activePage);
    const fillSize = getFillSize(placeholdersSize, origImageSize, bookSizes, 0);
    dispatch(changeFillImageSize(fillSize, placeholdersImage.id, 0));
    const coverRatio = bookProperties.cover.coverSizes.hasOwnProperty('heightInPx') ? bookProperties.cover.coverSizes.heightInPx / bookProperties.dimensions.layoutHeight : 1;
    const center = setImageToCenter(layoutplaceholders, placeholdersImage.id, imagesById, bookSizes, null, coverRatio, activePage.isCover);
    dispatch(resetAllTransformations(placeholdersImage.id, center));


    return null;
  }

  dispatch(addDroppedImage(pageId, imageId));

  const isCoverPage = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.isCover`,
  );

  const isFrontFlyLeaf = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.isFrontFlyLeaf`,
  );
  const isBackFlyLeaf = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.isBackFlyLeaf`,
  );

  const isBabyPage = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.isBabyPage`,
  );


  const layouts = dotProp.get(getState(), 'entities.layouts.byId');
  const droppedImages = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.droppedImages`,
  );


  const orderedLayouts = orderBy(convertObjectToArray(layouts), 'order');
  const orderedPages = orderBy(getPages(convertObjectToArray(getInnerLayouts(layouts)), 'order'));

  const babyLayouts = Object.values(layouts).filter(element => element.isBabyPlaceholder);
  const getBabyLayouts = orderBy(convertObjectToArray(babyLayouts), 'order');

  const currentLayout = dotProp.get(
    getState(),
    `entities.pages.byId.${pageId}.placeholders`,
  );
  const droppedImagesOrientation = convertObjectToArray(droppedImages).map(image =>
    dotProp.get(
      getState(),
      `entities.images.byId.${image.imageId}.orientation`,
    ));


  let layout = '';

  if (isCoverPage) {
    layout = isNotBelivPage('isCover', orderedLayouts, droppedImages).id;
  } else if (isFrontFlyLeaf) {
    layout = isNotBelivPage('isFrontFlyleaf', orderedLayouts, droppedImages).id;
  } else if (isBackFlyLeaf) {
    layout = isNotBelivPage('isBackFlyleaf', orderedLayouts, droppedImages).id;
  } else if (isBabyPage) {
    layout = setLayoutByOrientation(
      droppedImagesOrientation,
      droppedImages,
      getBabyLayouts,
      'isBabyPlaceholder',
    );
  } else {
    layout = setLayoutByOrientation(
      droppedImagesOrientation,
      droppedImages,
      orderedPages,
    );
  }

  const isChanged = currentLayout.length > droppedImages.length;
  if (!isChanged && layout) {
    dispatch(setLayoutToActivePage(layout, pageId));
  }
};


export const removeImage = (pageId, placeholderId) => (dispatch, getState) => {
  const getTexureId = dotProp.get(getState(), `entities.placeholders.byId.${placeholderId}`);
  if (getTexureId) {
    const textureImageId = getTexureId.image;
    dispatch(removeDroppedImage(pageId, textureImageId));

    const layouts = dotProp.get(getState(), 'entities.layouts.byId');
    const orderedPages = orderBy(getPages(convertObjectToArray(getInnerLayouts(layouts)), 'order'));

    const droppedImages = dotProp.get(
      getState(),
      `entities.pages.byId.${pageId}.droppedImages`,
    );

    const droppedImagesOrientation = convertObjectToArray(droppedImages).map(image =>
      dotProp.get(
        getState(),
        `entities.images.byId.${image.imageId}.orientation`,
      ));

    const layout = setLayoutByOrientation(
      droppedImagesOrientation,
      droppedImages,
      orderedPages,
    );

    if (layout) {
      dispatch(setLayoutToActivePage(layout, pageId, false, true));
    }
  }
};

export const removeDroppedImage = (pageId, imageId) => ({
  type: REMOVE_DROPPED_IMAGE,
  pageId,
  imageId,
});

export const removeChangedImage = (pageId, imageId) => ({
  type: REMOVE_CHANGED_IMAGE,
  pageId,
  imageId,
});

export const removeTextureFromPage = (pageId, placeholderId) => ({
  type: {
    type: REMOVE_TEXTURE_FROM_PAGE,
    pageId,
    placeholderId,
  },
  pageId,
  placeholderId,
});

export const updatePagesOrder = (pagesOrderedArray, oldIndex, newIndex) => ({
  type: UPDATE_PAGES_ORDER,
  pagesOrderedArray,
  oldIndex,
  newIndex,
});

export const changeImage = (
  pageId,
  dragplaceholderId,
  dragOrder,
  dropplaceholderId,
  targetOrder,
) => ({
  type: CHANGE_IMAGE,
  pageId,
  dragplaceholderId,
  dragOrder,
  dropplaceholderId,
  targetOrder,
});

export const removeImageFromFlyLeaf = (pageId, placeholderId) => (
  dispatch,
  getState,
) => {
  const droppedImage = dotProp.get(
    getState(),
    `entities.placeholders.byId.${placeholderId}.image`,
  );

  if (!droppedImage) {
    return false;
  }

  dispatch(removeDroppedImage(pageId, droppedImage));
  dispatch(removeImageFromTexture(placeholderId));
};

export const reorderPlaceholders = (currentPage, allImageById) => ({
  type: REORDER_PLACEHOLDERS,
  currentPage,
  allImageById,
});

export const assigneImageIdToPagePlaceholders = (currentPage, entitiesPlaceholders) => ({
  type: ASSIGNE_IMAGE_ID_TO_PAGE_PLACEHOLDERS,
  currentPage,
  entitiesPlaceholders,
});

export const changePagesBackgroundColor = color => ({
  type: CHANGE_PAGES_BACKGROUND_COLOR,
  color,
});

export const changePageBackgroundColorById = (pageId, order, color) => ({
  type: CHANGE_PAGES_BACKGROUND_COLOR_BY_ID,
  pageId,
  order,
  color,
});

export const loadPagesByBookId = bookState => ({
  type: LOAD_PAGES_BY_BOOK_ID,
  bookState,
});

export const addTextToPage = (pageId, textId) => ({
  type: ADD_TEXT_TO_PAGE,
  pageId,
  textId,
});

export const deleteTextFromPage = textId => ({
  type: DELETE_TEXT_FROM_PAGE,
  textId,
});

/* Wedding bg */

export const addBackgroundImageToPage = (category, layouts, backgrounds, fileName, types) => ({
  type: ADD_BACKGROUND_IMAGE_TO_PAGE,
  category,
  layouts,
  backgrounds,
  fileName,
  types,
});

export const changePagesBackgroundImage = (thumbnail, full, sizes) => ({
  type: CHANGE_PAGES_BACKGROUND_IMAGES,
  thumbnail,
  full,
  sizes,
});

export const addBackgroundPropertyToPage = (pageId, property, value) => ({
  type: ADD_BACKGROUND_PROP_TO_PAGE,
  pageId,
  property,
  value,
});



// WEBPACK FOOTER //
// ./src/redux/actions/entities/pages.js